module.exports = __webpack_public_path__ + "media/widget/Problems-f62dbcae.png";